import type { CoachingModal as Modal } from '@/core/state/appStore'
import { COLUMNS } from './columns'

export const ACTION_TO_MODAL: Record<string, Modal> = {
  'open-avgs': 'avgs',
  'open-bewilligung': 'bewilligung',
  'open-vertrag': 'vertrag',
  'open-ecn': 'ecn',
  'open-abschluss': 'abschluss',
}

export const ENTRY = { label: "Erstgespräch", action: 'open-erstgespraech' } as const

export function isDeleteLocked(coaching: { stage: string; documents: readonly string[] }): boolean {
  if (coaching.documents.includes('vertrag')) return true
  const vertrag = COLUMNS.findIndex((c) => c.id === 'vertrag')
  return COLUMNS.findIndex((c) => c.id === coaching.stage) > vertrag
}
